// extracted by mini-css-extract-plugin
module.exports = {"summary":"ConfimationModal_summary__1kl4B","summaryRow":"ConfimationModal_summaryRow__1a7rd","coinText":"ConfimationModal_coinText__3yq-Z","coin":"ConfimationModal_coin__2lVwg"};